const initialState = {
  data: null,
  loading: null,
  error: null,
  filters: {
    offset: 0,
    limit: 9999,
  },
};

export default initialState;
